<template lang="pug">
div
    template(v-if="isLoading")
        .text-center
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px;"
            )
    template(v-else-if="validCommunicationManager")
        v-list-item
            v-list-item-icon
                v-icon(color='primary')
                    | mdi-account-cog
            v-list-item-content
                v-list-item-title Communication Preferences
        
        v-list-item
            v-list-item-icon
            v-list-item-content
                v-list-item-title 
                    v-icon.mr-1 mdi-check-all
                    | All communications
                v-list-item-subtitle
            v-list-item-action
                template(v-if="isSettingLoading('subscribedCommunicationTypeAll')")
                    v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                template(v-else)
                    v-checkbox(
                        v-model='subscribedCommunicationTypeAll'
                        :disabled="hideCreateUpdateDestroyButtons || !currentUserCanEditCommunicationPreferences"
                        @change="handleCreateOptInOut('subscribedCommunicationTypeAll')"
                        ripple
                        dense
                    )

        //- v-list-item
        //-     v-list-item-icon
        //-     v-list-item-content
        //-         v-list-item-title Receive mail communications
        //-         v-list-item-subtitle
        //-     v-list-item-action
        //-         v-checkbox(
        //-             v-model='subscribedCommunicationTypeMail'
        //-             dense
        //-             ripple
        //-             @change="handleCreateOptInOut('subscribedCommunicationTypeMail')"
        //-             :disabled="hideCreateUpdateDestroyButtons"
        //-         )

        v-list-item
            v-list-item-icon
            v-list-item-content
                v-list-item-title
                    v-icon.mr-1 mdi-email
                    | Email communications
                v-list-item-subtitle
            v-list-item-action
                template(v-if="isSettingLoading('subscribedCommunicationTypeEmail')")
                    v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                template(v-else)
                    v-checkbox(
                        v-model='subscribedCommunicationTypeEmail'
                        :disabled="hideCreateUpdateDestroyButtons || !currentUserCanEditCommunicationPreferences"
                        @change="handleCreateOptInOut('subscribedCommunicationTypeEmail')"
                        ripple
                        dense
                    )

        v-list-item
            v-list-item-icon
            v-list-item-content
                v-list-item-title 
                    v-icon.mr-1 mdi-phone
                    | Phone call communications
                v-list-item-subtitle
            v-list-item-action
                template(v-if="isSettingLoading('subscribedCommunicationTypePhone')")
                    v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                template(v-else)
                    v-checkbox(
                        v-model='subscribedCommunicationTypePhone'
                        :disabled="hideCreateUpdateDestroyButtons || !currentUserCanEditCommunicationPreferences"
                        @change="handleCreateOptInOut('subscribedCommunicationTypePhone')"
                        ripple
                        dense
                    )

        v-list-item
            v-list-item-icon
            v-list-item-content
                v-list-item-title 
                    v-icon.mr-1 mdi-cellphone
                    | SMS message communications
                v-list-item-subtitle
            v-list-item-action
                template(v-if="isSettingLoading('subscribedCommunicationTypeMessage')")
                    v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                template(v-else)
                    v-checkbox(
                        v-model='subscribedCommunicationTypeMessage'
                        :disabled="hideCreateUpdateDestroyButtons || !currentUserCanEditCommunicationPreferences"
                        @change="handleCreateOptInOut('subscribedCommunicationTypeMessage')"
                        ripple
                        dense
                    )

        v-divider.mr-5(style="margin-left: 0px;")

        template(v-if="customerEmailAddresses?.length > 0")
            v-list-item
                v-list-item-icon
                    v-icon(color='primary')
                        | mdi-email
                v-list-item-content
                    v-list-item-title Email Addresses

            v-list-item(
                v-for='(customerEmailAddress, idx) in customerEmailAddresses'
                :key='customerEmailAddress.customer_email_address_id'
            )
                v-list-item-icon
                    v-icon(v-show="false" color='primary')
                        | mdi-email
                v-list-item-content
                    v-list-item-title
                        CopyableText(:text="customerEmailAddress.email_address_email")
                v-list-item-action
                    v-tooltip(top)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-email
                        span
                            | Email
                v-list-item-action.ml-2
                    template(v-if="isSettingLoading(customerEmailAddress.vid)")
                        v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                    template(v-else)
                        v-checkbox(
                            v-model='customerEmailAddress.email_is_subscribed'
                            @change="createCustomerEmailOptInOut(customerEmailAddress)"
                            :disabled="!allowEmailOptInOutEdit"
                            ripple
                            dense
                        )
        template(v-else)
            v-list-item
                v-list-item-icon
                    v-icon(color='primary')
                        | mdi-email
                v-list-item-content
                    v-list-item-title Email Addresses
            v-alert.text-center(type="info" :icon="false" outlined dense)
                | No email addresses associated with this customer

        v-divider.mr-5(style="margin-left: 0px;")

        template(v-if="customerPhoneNumbers?.length > 0")
            v-list-item
                v-list-item-icon
                    v-icon(color='primary')
                        | mdi-phone
                v-list-item-content
                    v-list-item-title Phone Numbers

            v-list-item(
                v-for='(customerPhoneNumber, idx) in customerPhoneNumbers'
                :key='idx'
            )
                v-list-item-icon
                    v-icon(v-show="false" color='primary')
                        | mdi-phone
                v-list-item-content
                    v-list-item-title
                        CopyablePhoneNumber(:phone-number="customerPhoneNumber")
                    v-list-item-subtitle
                        | {{ (customerPhoneNumber.phone_number_type || 'Unknown') | titleize }}
                v-list-item-action
                    v-tooltip(top)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-phone
                        span
                            | Phone Call
                v-list-item-action.ml-2
                    template(v-if="isSettingLoading(customerPhoneNumber.vid + 'call_is_subscribed')")
                        v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                    template(v-else)
                        v-checkbox(
                            v-model='customerPhoneNumber.call_is_subscribed'
                            @change="createCustomerPhoneNumberOptInOut(customerPhoneNumber, 'call_is_subscribed')"
                            :disabled="!allowPhoneCallOptInOutEdit"
                            ripple
                            dense
                        )
                v-list-item-action.ml-5
                    v-tooltip(top)
                        template(v-slot:activator='{ on, attrs }')
                            span(v-bind="attrs" v-on="on" role="text")
                                v-icon mdi-cellphone
                        span
                            | Message
                v-list-item-action.ml-2
                    template(v-if="isSettingLoading(customerPhoneNumber.vid + 'message_is_subscribed')")
                        v-progress-circular(:size='22' :width='3' color='var(--volie-blue)' indeterminate)
                    template(v-else)
                        v-checkbox(
                            v-model='customerPhoneNumber.message_is_subscribed'
                            @change="createCustomerPhoneNumberOptInOut(customerPhoneNumber, 'message_is_subscribed')"
                            :disabled="!allowPhoneMessageOptInOutEdit"
                            ripple
                            dense
                        )
        template(v-else)
            v-list-item
                v-list-item-icon
                    v-icon(color='primary')
                        | mdi-phone
                v-list-item-content
                    v-list-item-title Phone Numbers
            v-alert.text-center(type="info" :icon="false" outlined dense)
                | No phone numbers associated with this customer

        v-divider.mr-5(style="margin-left: 0px;")

        v-list-item
            v-list-item-icon
                v-icon(color='primary')
                    | mdi-history
            v-list-item-content
                v-list-item-title Opt Out History

        OptInOutIndex(
            :communication-manager="communicationManager"
            :opt-in-outs="optInOuts"
        )

</template>

<script lang="ts">
import Vue from 'vue';

// Data
import { CreateOptInOut, GetOptInOuts, GetCustomerCommunicationManager, } from "@/data";

// Componenets
import CopyablePhoneNumber from '@/components/shared/copyable_phone_number.vue';
import CopyableText from '@/components/shared/copyable_text.vue';
import OptInOutIndex from '@/components/communication_center/shared/tabs/opt_in_out_index.vue';
import VolieState from '@/store';

export default Vue.extend({
    data() {
        return {
            communicationManager: null,
            hasLoaded: false,
            isLoading: false,
            loadingIds: [],
            optInOuts: [],
            subscribedCommunicationTypeAll: false,
            subscribedCommunicationTypeMail: false,
            subscribedCommunicationTypeEmail: false,
            subscribedCommunicationTypePhone: false,
            subscribedCommunicationTypeMessage: false,
        }
    },
    methods: {
        async createCustomerEmailOptInOut(item) {
            if (item === null) {
                return;
            }

            const options = {
                action:                 item.email_is_subscribed ? 'subscribe' : 'unsubscribe',
                communication_type:     'email',
                optable_id:             item.customer_email_address_id,
                optable_type:           'customer_email_address',
                source:                 'customer_profile',
            }

            if (this.inCommunicationCenter) {
                options.source = "communication_center";
            }

            const success = await this.createOptInOut(options, item.vid);
            if (!success) {
                item.email_is_subscribed = !item.email_is_subscribed;
            }
        },
        async createCustomerPhoneNumberOptInOut(item, method) {
            if (item === null || !(method?.length > 0)) {
                return;
            }

            const options = {
                action:                 item[method] ? 'subscribe' : 'unsubscribe',
                communication_type:     method === 'call_is_subscribed' ? 'phone' : 'message',
                optable_id:             item.customer_phone_number_id,
                optable_type:           'customer_phone_number',
                source:                 'customer_profile',
            }

            if (this.inCommunicationCenter) {
                options.source = "communication_center";
            }

            const success = await this.createOptInOut(options, item.vid + method);
            if (!success) {
                item[method] = !item[method];
            }
        },
        async createOptInOut(options, key) {
            
            // Verify valid current campaign customer for in communicatino center and valid customer otherwise
            // Note - this might have to change when supporting contact opt out
            if ((this.inCommunicationCenter && !(this.currentCampaignCustomer?.campaign_customer_id > 0))) {
                return;
            }
            
            // Set on options
            options.campaign_customer_id = (this.currentCampaignCustomer.campaign_customer_id || 0);

            // todo
            // eventable_id
            // eventable_type

            this.loadingIds.push(key);

            const result = CreateOptInOut(options).then((response) => {
                this.loadingIds = this.loadingIds.filter(x => x !== key);

                if (response?.Data?.opt_in_out?.id > 0) {
                    this.showSnackbar("success", "Successfully updated communication preference");

                    // Set changes on communication manager
                    this.setSubscriptionChangesOnCommunicationManager(response);
                    this.setSubscribedData();
                    this.getOptInOuts();
                    return true;
                } else {
                    this.showSnackbar("error", "Something went wong updating communication preference");
                }

                return false;
            });

            return result;
        },
        async getCustomerCommunicationManager() {
            if (this.customerCommunicationManager != null) {
                this.communicationManager = this.customerCommunicationManager;
                return;
            }

            const options = {
                customer_id: this.currentCampaignCustomer?.customer_id || 0,
            }

            this.isLoading = true;
            await GetCustomerCommunicationManager(options).then((response) => {
                if (response?.Data?.communication_manager?.customer_id > 0 && response?.Data?.communication_manager?.customer_id === this.currentCampaignCustomer?.customer_id) {
                    this.communicationManager = response.Data.communication_manager;
                }
                this.isLoading = false;
                this.setSubscribedData();
            });
        },
        getOptInOuts() {
            const options = {
                customer_id: this.currentCampaignCustomer?.customer_id || 0,
            }

            this.isLoading = true;
            GetOptInOuts(options).then((response) => {
                this.isLoading = false;

                if (response?.Data?.opt_in_outs?.length > 0) {
                    this.optInOuts = response.Data.opt_in_outs;
                }
            })
        },
        handleCreateOptInOut(key) {

            // Verify valid key
            if (!(key?.length > 0)) {
                return;
            }

            // Determine action
            let action = "unsubscribe";
            if (this[key] === true) {
                action = "subscribe";
            }

            const options = {
                action: action,
                communication_type: null,
                optable_id: this.communicationManager.customer_id,
                optable_type: "customer",
                source: "customer_profile",
            }

            if (this.inCommunicationCenter) {
                options.source = "communication_center";
            }

            switch(key) {
            case "subscribedCommunicationTypeAll":
                options.communication_type = "all";
                break;

            case "subscribedCommunicationTypeEmail":
                options.communication_type = "email";
                break;

            case "subscribedCommunicationTypeMail":
                options.communication_type = "mail";
                break;

            case "subscribedCommunicationTypeMessage":
                options.communication_type = "message";
                break;

            case "subscribedCommunicationTypePhone":
                options.communication_type = "phone";
                break;
            }

            // Return if invalid communication type
            if (!(options?.communication_type?.length > 0)) {
                return;
            }

            this.createOptInOut(options, key);
        },
        async init() {
            await this.getCustomerCommunicationManager();
            this.getOptInOuts();
            this.setSubscribedData();
        },
        isSettingLoading(key) {
            return this.loadingIds?.includes(key);
        },
        setSubscriptionChangesOnCommunicationManager(response) {

            // Verify response communication manager matches data cm
            if (!(this.communicationManager?.customer_id > 0 && response?.Data?.customer_communication_manager?.customer_id > 0 && response?.Data?.customer_communication_manager?.customer_id === this.communicationManager?.customer_id)) {
                return;
            }

            // Customer level subscribes
            this.communicationManager.subscribed_communication_type_all = response.Data.customer_communication_manager.subscribed_communication_type_all;
            this.communicationManager.subscribed_communication_type_email = response.Data.customer_communication_manager.subscribed_communication_type_email;
            this.communicationManager.subscribed_communication_type_mail = response.Data.customer_communication_manager.subscribed_communication_type_mail;
            this.communicationManager.subscribed_communication_type_message = response.Data.customer_communication_manager.subscribed_communication_type_message;
            this.communicationManager.subscribed_communication_type_phone = response.Data.customer_communication_manager.subscribed_communication_type_phone;
            this.communicationManager.opt_in_outs = response.Data.customer_communication_manager.opt_in_outs;
        },
        setSubscribedData() {
            if (this.communicationManager === null) {
                return;
            }

            this.subscribedCommunicationTypeAll = this.communicationManager.subscribed_communication_type_all;
            this.subscribedCommunicationTypeMail = this.communicationManager.subscribed_communication_type_mail;
            this.subscribedCommunicationTypeEmail = this.communicationManager.subscribed_communication_type_email;
            this.subscribedCommunicationTypePhone = this.communicationManager.subscribed_communication_type_phone;
            this.subscribedCommunicationTypeMessage = this.communicationManager.subscribed_communication_type_message;
        },
    },
    computed: {
        allowEmailOptInOutEdit() {
            return this.subscribedCommunicationTypeAll && this.subscribedCommunicationTypeEmail && !this.isSettingLoading('subscribedCommunicationTypeEmail') && this.currentUserCanEditCommunicationPreferences;
        },
        allowPhoneCallOptInOutEdit() {
            return this.subscribedCommunicationTypeAll && this.subscribedCommunicationTypePhone && !this.isSettingLoading('subscribedCommunicationTypePhone') && this.currentUserCanEditCommunicationPreferences;
        },
        allowPhoneMessageOptInOutEdit() {
            return this.subscribedCommunicationTypeAll && this.subscribedCommunicationTypeMessage && !this.isSettingLoading('subscribedCommunicationTypeMessage') && this.currentUserCanEditCommunicationPreferences;
        },
        currentUser() {
            return VolieState.currentUser();
        },
        currentUserCanEditCommunicationPreferences() {
            return this.currentUser?.account_user?.edit_communication_preferences_enabled === true;
        },
        customerEmailAddresses() {
            return this.communicationManager?.customer_email_addresses || [];
        },
        customerPhoneNumbers() {
            return this.communicationManager?.customer_phone_numbers || [];
        },
        validCommunicationManager() {
            return this.communicationManager?.customer_id > 0;
        },
    },
    components: {
        CopyablePhoneNumber,
        CopyableText,
        OptInOutIndex,
    },
    props: {
        customerCommunicationManager: Object,
        currentCampaignCustomer: Object,
        hideCreateUpdateDestroyButtons: Boolean,
        inCommunicationCenter: Boolean,
        isShown: Boolean,
        showSnackbar: Function,
    },
    watch: {
        isShown() {
            if (this.isShown && !this.hasLoaded) {
                this.hasLoaded = true;
                this.init();
            }
        },
    },
    created() {
    },
});
</script>

<style lang="scss" scoped>
    #app {
        .list-item-title-overflow {
            overflow: auto !important;
            white-space: normal !important;
        }
    }
</style>
